import {BaseTrackingEvent} from '@udemy-v2/event-tracking';

export enum BrowseNavigationItemType {
    TOPIC = 'topic',
    CATEGORY = 'category',
    SUBCATEGORY = 'subcategory',
    BADGE = 'badge',
    RECOMMENDATION_COLLECTION = 'recommendation_collection',
}
export enum BrowseNavigationItemStyle {
    PILL_DARK = 'pill_dark',
    PILL_LIGHT = 'pill_light',
    BLOCK = 'block',
    NAVIGATION_TAB = 'navigation_tab',
    NAVIGATION_DROPDOWN = 'navigation_dropdown',
    LINK = 'link',
}

export class BrowseNavigationItemSelected implements BaseTrackingEvent {
    _type = 'BrowseNavigationItemSelected';
    id: string;
    type: BrowseNavigationItemType;
    uiRegion: string;
    style: BrowseNavigationItemStyle;

    constructor({
        id,
        type,
        uiRegion,
        style,
    }: {
        id: string;
        type: BrowseNavigationItemType;
        uiRegion: string;
        style: BrowseNavigationItemStyle;
    }) {
        this.id = id;
        this.type = type;
        this.uiRegion = uiRegion;
        this.style = style;
    }
}
